import { SlackUser } from '../../../domain/value-object/Slack/UserVO'
import { SlackWorkspace } from '../../../domain/value-object/Slack/WorkspaceVO'
import API from '../../../lib/commons/api'

// 接続失敗時、api.tsのfetchラッパーは通知を出したうえで空の成功応答（json: {}）を
// 返す。「未連携」として扱わず、かつ通知を重ねないよう、例外ではなく undefined を返す。
export const getAuthorizedSlackWorkspaces = async (): Promise<
  SlackWorkspace[] | undefined
> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/slack/workspaces/authorized'
  )
  if (!Array.isArray(response.json)) return undefined
  return response.json
}

// 上と同じ理由で、接続失敗時は「メンバー0人」ではなく undefined を返す。
export const getSlackWorkspaceUsers = async (
  slackWorkspaceId: string
): Promise<SlackUser[] | undefined> => {
  const response = await API.functional.request('GET', '/api/v1/slack/users', {
    slackWorkspaceId,
  })
  if (!Array.isArray(response.json)) return undefined
  return response.json
}
